// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DevToolsPopup__popup-e1d90c {
  width: 300px;
  height: 300px;
  color: var(--base-80);
  max-height: 300px;
}

.DevToolsPopup__divider-ec8814 {
  width: 100%;
  height: 1px;
  margin: 0;
  background-color: var(--base-20);
}

.DevToolsPopup__flex-row-e27623 {
  display: flex;
  flex-direction: row;
}

.DevToolsPopup__flex-column-cfaa1e {
  display: flex;
  flex-direction: column;
}

.DevToolsPopup__flex-space-between-d0af2a {
  justify-content: space-between;
}

.DevToolsPopup__flex-align-center-f65833 {
  align-items: center;
}

.DevToolsPopup__flex-end-f3b81d {
  justify-content: flex-end;
}

.DevToolsPopup__flex-start-ae3bcf {
  justify-content: flex-start;
}

.DevToolsPopup__gap-16-a641f8 {
  gap: 16px;
}

.DevToolsPopup__gap-8-c1c46a {
  gap: 16px;
}

.DevToolsPopup__gap-32-b60d48 {
  gap: 32px;
}

.DevToolsPopup__gap-48-b7bb09 {
  gap: 48px;
}

.DevToolsPopup__padding-32-e11b0d {
  padding: 32px;
}

.DevToolsPopup__width-100-e26a09 {
  width: 100%;
}

.DevToolsPopup__height-100-db2475 {
  height: 100%;
}

.DevToolsPopup__overflow-hidden-d3db7d {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/DevToolsPopup/DevToolsPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,qBAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;EACA,SAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,8BAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".popup {\n  width: 300px;\n  height: 300px;\n  color: var(--base-80);\n  max-height: 300px;\n}\n\n.divider {\n  width: 100%;\n  height: 1px;\n  margin: 0;\n  background-color: var(--base-20);\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column;\n}\n\n.flex-space-between {\n  justify-content: space-between;\n}\n\n.flex-align-center {\n  align-items: center;\n}\n\n.flex-end {\n  justify-content: flex-end;\n}\n\n.flex-start {\n  justify-content: flex-start;\n}\n\n.gap-16 {\n  gap: 16px;\n}\n\n.gap-8 {\n  gap: 16px;\n}\n\n.gap-32 {\n  gap: 32px;\n}\n\n.gap-48 {\n  gap: 48px;\n}\n\n.padding-32 {\n  padding: 32px;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n.height-100 {\n  height: 100%;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `DevToolsPopup__popup-e1d90c`,
	"divider": `DevToolsPopup__divider-ec8814`,
	"flex-row": `DevToolsPopup__flex-row-e27623`,
	"flexRow": `DevToolsPopup__flex-row-e27623`,
	"flex-column": `DevToolsPopup__flex-column-cfaa1e`,
	"flexColumn": `DevToolsPopup__flex-column-cfaa1e`,
	"flex-space-between": `DevToolsPopup__flex-space-between-d0af2a`,
	"flexSpaceBetween": `DevToolsPopup__flex-space-between-d0af2a`,
	"flex-align-center": `DevToolsPopup__flex-align-center-f65833`,
	"flexAlignCenter": `DevToolsPopup__flex-align-center-f65833`,
	"flex-end": `DevToolsPopup__flex-end-f3b81d`,
	"flexEnd": `DevToolsPopup__flex-end-f3b81d`,
	"flex-start": `DevToolsPopup__flex-start-ae3bcf`,
	"flexStart": `DevToolsPopup__flex-start-ae3bcf`,
	"gap-16": `DevToolsPopup__gap-16-a641f8`,
	"gap16": `DevToolsPopup__gap-16-a641f8`,
	"gap-8": `DevToolsPopup__gap-8-c1c46a`,
	"gap8": `DevToolsPopup__gap-8-c1c46a`,
	"gap-32": `DevToolsPopup__gap-32-b60d48`,
	"gap32": `DevToolsPopup__gap-32-b60d48`,
	"gap-48": `DevToolsPopup__gap-48-b7bb09`,
	"gap48": `DevToolsPopup__gap-48-b7bb09`,
	"padding-32": `DevToolsPopup__padding-32-e11b0d`,
	"padding32": `DevToolsPopup__padding-32-e11b0d`,
	"width-100": `DevToolsPopup__width-100-e26a09`,
	"width100": `DevToolsPopup__width-100-e26a09`,
	"height-100": `DevToolsPopup__height-100-db2475`,
	"height100": `DevToolsPopup__height-100-db2475`,
	"overflow-hidden": `DevToolsPopup__overflow-hidden-d3db7d`,
	"overflowHidden": `DevToolsPopup__overflow-hidden-d3db7d`
};
module.exports = ___CSS_LOADER_EXPORT___;
